import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Api } from 'src/app/shared/constants/api';
import { DataService } from 'src/app/shared/services/data.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { MustMatch } from '../reset-password/reset-password.component';


@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.component.html',
    styleUrls: ['./set-password.component.less'],
    standalone: false
})
export class SetPasswordComponent implements OnInit {

  constructor(private formBuilder:FormBuilder,private activatedRoute:ActivatedRoute,
              private router:Router,private logger:NGXLogger,private service:DataService,
              private utilityService:UtilityService) { }

  hide=true;
  oldHide=true;
  setPasswordForm:FormGroup;
  ngOnInit(): void 
  {
    this.initializeForm();
    this.activatedRoute.queryParams.subscribe(params => {
      this.logger.info('param ', params);
      this.key = params['key'];
      this.logger.info('key for redirectedUrl ', this.key);
    });
  }

  initializeForm()
  {
    this.setPasswordForm= this.formBuilder.group({
      verficationCode: [null,[Validators.required]],
      newPassword:[null,[Validators.required]],
      oldPassword:[null,[Validators.required]],
      key:[]
    }, {
      validator: MustMatch('newPassword', 'oldPassword')
  });
  }

  public onSave() {
    this.logger.info('set password form data before validation : ', this.setPasswordForm.value);
    this.setPasswordForm.markAllAsTouched();
    if(this.setPasswordForm.valid){
      this.service.post(Api.RESET_PASSWORD , this.setPasswordForm.value).subscribe(res =>{
        this.logger.info('rest password res', res);
        this.utilityService.notifier(res.response,'success');
        this.router.navigate(['/login'])
      });
    }
  }

  public onCancel(){
    this.router.navigate(['/login'])
  }

  
  private get key(){ return this.setPasswordForm.get('key')?.value; }
  get verificationCode(){return this.setPasswordForm.get('verficationCode');}
  get newPassword(){return this.setPasswordForm.get('newPassword');}
  get confirmPassword(){return this.setPasswordForm.get('oldPassword');}
  private set key(key:string){ this.setPasswordForm.get('key').setValue(key);}
}


